import BrandedStreams from './BrandedStreams';

export default BrandedStreams;
